<template>
  <div class="mall-3d-icon" :style="{ width: size + 'px', height: size + 'px' }">
    <img class="mall-3d-icon__img" :src="src" alt="" />
    <!-- Figma와 동일하게 같은 이미지를 screen 블렌드로 한 번 더 겹쳐 밝게 표현 -->
    <img
      class="mall-3d-icon__img mall-3d-icon__img--screen"
      :src="src"
      :style="{ opacity: screenOpacity }"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: 'Mall3dIcon',
  props: {
    src: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 52,
    },
    // screen 블렌드로 겹치는 이미지의 투명도
    screenOpacity: {
      type: Number,
      default: 0.8,
    },
  },
}
</script>

<style scoped>
.mall-3d-icon {
  position: relative;
  flex-shrink: 0;
}

.mall-3d-icon__img {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mall-3d-icon__img--screen {
  mix-blend-mode: screen;
}
</style>



// WEBPACK FOOTER //
// src/components/new/atoms/Mall3dIcon.vue